<template>
	<div>
		<nav-bar needBack="0">
			<div :class="[bgClass]" class="w-full flex items-center justify-between px-30 h-128 relative">
					<div v-if="isHome" class="w-60 h-60 ">
						<img class="w-full h-full" src="~@/assets/images/common/img_logo.png" alt="">
					</div>
					<div v-else @click="goBack()" class="w-60 h-60 flex items-center justify-center">
						<img class="w-32 h-32" src="~@/assets/images/common/back.png" alt="">
					</div>
				<div class="ml-20 flex-1 flex items-center">
					<span class="font-bold text-white text-36"> {{ title }} </span>
				</div>
				<div class="flex items-center ">
					<div v-if="showLang" @click="showLanguage"
						class="flex items-center justify-center border border-solid border-white rounded-20 px-20 h-60">
						<img class="w-32 h-32" src="~@/assets/images/common/icon_yy.png" alt="">
						<span class="w-40 ml-10 text-24 text-white text-ellipsis">{{ $t('当前语言') }}</span>
						<img class="w-30 h-30" src="~@/assets/images/common/icon_zk.png" alt="">
					</div>
					<div
						class="ml-20 flex items-center justify-center border border-solid border-primary bg-primary/20 rounded-20 px-20 h-60">
						<img class="w-32 h-32" src="~@/assets/images/common/icon_lj.png" alt="">
						<span class="w-100 ml-10 text-24 text-white text-ellipsis">{{ walletInfo.show_address
							||
							$t('公共.链接钱包')}}</span>
					</div>
				</div>
			</div>
		</nav-bar>
		<LanguageSelect ref="languageSelect" />
	</div>
</template>

<script>
import navBar from '@/components/nav-bar/nav-bar.vue';
import LanguageSelect from '@/components/language-select/language-select.vue';
import api from "@/request/api.js";
import store from '@/store/index.js';
import utils from "@/utils/utils.js";
export default {
	props: {
		title: {
			type: String,
			default: ''
		},
		showLang: {
			type: Boolean,
			default: true
		},
		bgClass: {
			type: String,
			default: 'bg-transparent'
		},
		isHome: {
			type: Boolean,
			default: false
		},
	},
	components: {
		navBar,
		LanguageSelect,
	},
	data() {
		return {}
	},
	computed: {
		walletInfo() {
			return store.state.walletInfo;
		}
	},
	created() { },
	methods: {
		goBack() {
			utils.goBack();
		},
		showLanguage() {
			this.$refs.languageSelect.open();
		},
		showMenu() {
			if (store.state.menuShow) {
				store.commit('SET_VALUE', {
					key: 'menuShow',
					value: false,
				});
			} else {
				store.commit('SET_VALUE', {
					key: 'menuShow',
					value: true,
				});
			}
		}
	},
}
</script>

<style></style>
